var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"6","lg":"4","xl":"3"}},[_c('v-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }